import { useEffect, useRef, useState } from "react";
import ContactModal from "./Modal";

function Navbar() {
  const [showHeader, setShowHeader] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);



  return (
    <>
      <header>
        {/*  <div class="sticky-call-button">*/}
        {/*  <a href="tel:6465586550" class="call-btn">*/}
        {/*    <span class="btn-text">Schedule a Call</span>*/}
        {/* <span class="phone-number">(646) 760-7313</span> */}
        {/*  </a>*/}
        {/*</div>*/}
        <div className="container">
          <div className="row">
            <div className="logodiv" style={{marginTop: 15}}>
              <a href="index.html">
                <img
                  className="logo-img"
                  src="professional-website-development/assets/images/logo-main.webp"
                  alt=""
                />
              </a>
            </div>
          <div className="contact-sec">
            <a href="tel:+16467607313">Call Us (646) 760-7313</a>
            <a className="various grad-btn" style={{cursor: 'pointer'}} name={149} onClick={openModal}>
              Get a Free Quote
            </a>
            {/* <a
              href="javascript:;"
              className="chat grad-btn"
              style={{ marginLeft: 15 }}
            >
              Live Chat
            </a> */}
          </div>
          </div>
        </div>
      </header>
      <ContactModal isOpen={showModal} onClose={closeModal} />
    </>
  );
}

export default Navbar;
